import { useCheckSession } from "../../Hooks/useCheckSession";

export default function SessionChecker() {
  useCheckSession();
  return null;
}
